import { render, staticRenderFns } from "./Despesas.vue?vue&type=template&id=2ba5fa9c&"
import script from "./Despesas.vue?vue&type=script&lang=js&"
export * from "./Despesas.vue?vue&type=script&lang=js&"
import style0 from "./Despesas.vue?vue&type=style&index=0&id=2ba5fa9c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports